/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Oct 25 2024
 **/

import { ComponentProps } from "react";

import { Avatar } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

export const AvatarStatusColorMap: Record<Users.ActiveStatus, ComponentProps<typeof Avatar>["status"]> = {
	ACTIVE: "Green",
	FOCUS: "Red",
	AWAY: "Yellow",
	OFFLINE: "Gray"
};

/**
 * Common Avatar Status Text Map
 */
export function AvatarStatusTextMap(key: SwaggerModels.UserActiveStatus): string {
	return {
		ACTIVE: _T("활동중"),
		FOCUS: _T("집중모드"),
		AWAY: _T("잠시 자리 비움"),
		OFFLINE: _T("오프라인")
	}[key];
}

/**
 * Avatar Status Profile Text Map for Me
 */
export function AvatarStatusProfileTextMap(key: SwaggerModels.UserActiveStatus): string {
	return {
		ACTIVE: _T("활동중 (자동)"),
		FOCUS: _T("집중모드"),
		AWAY: _T("잠시 자리 비움"),
		OFFLINE: _T("오프라인")
	}[key];
}
